import { render, staticRenderFns } from "./imprVendorRequest.vue?vue&type=template&id=755bd192"
import script from "./imprVendorRequest.vue?vue&type=script&lang=js"
export * from "./imprVendorRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('755bd192')) {
      api.createRecord('755bd192', component.options)
    } else {
      api.reload('755bd192', component.options)
    }
    module.hot.accept("./imprVendorRequest.vue?vue&type=template&id=755bd192", function () {
      api.rerender('755bd192', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/ibm/imprVendorRequest.vue"
export default component.exports